import { render } from "./LoadingDots.vue?vue&type=template&id=8d7f9042&scoped=true&ts=true"
import script from "./LoadingDots.vue?vue&type=script&lang=ts"
export * from "./LoadingDots.vue?vue&type=script&lang=ts"

import "./LoadingDots.vue?vue&type=style&index=0&id=8d7f9042&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d7f9042"]])

export default __exports__